export enum PropertyStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PROPOSED = 'proposed',
  COMMITTED = 'committed',
}
